import {CertificateRequest} from "../models/CertificateRequest";
import {HttpStatusCode} from "../models/HttpStatusCodes";
import {AlertTypes} from "../models/Enums";
import filesService from "./files.service";
import http from "./httpRequest";



class CertificatesService {
    private async wait(ms: number) {
        await new Promise((resolve) => setTimeout(resolve, ms));
    }

    async getAdvisorCertificatesProgress(periodId?: string) {
        const path = periodId ? `/certificates/progress/${periodId}` : `/certificates/progress`;
        const response = await http.get(path);
        return response?.data;
    }

    async getExportStatus(exportId: string) {
        const response = await http.get(`/certificates/exports/${exportId}`);
        return response?.data;
    }

    async downloadExport(exportId: string) {
        const response = await http.get(`/certificates/exports/${exportId}/download`, {
            responseType: 'blob'
        });
        return response;
    }

    async waitUntilExportCompleted(exportId: string, maxAttempts = 120, intervalMs = 2000) {
        for (let attempt = 0; attempt < maxAttempts; attempt++) {
            const status = await this.getExportStatus(exportId);
            if (status?.status === 'completed') {
                return status;
            }

            if (status?.status === 'failed') {
                const errorMessage = status?.error || 'Error al generar la exportación.';
                http.apiResponse.showError(errorMessage, AlertTypes.ERROR);
                return null;
            }

            await this.wait(intervalMs);
        }

        http.apiResponse.showError('La exportación está tardando más de lo esperado.', AlertTypes.WARNING);
        return null;
    }

    // Crud operations for education programs
    async generateCertificates(data: CertificateRequest) {
        const response = await http.post(`/certificates/generateZipFile`, data);

        if (response?.status !== 202) {
            return;
        }

        const exportId = response?.data?.exportId;
        if (!exportId) {
            http.apiResponse.showError('No se pudo iniciar la exportación de certificados.', AlertTypes.ERROR);
            return;
        }

        http.apiResponse.showLoader('Generando certificados...');
        try {
            const status = await this.waitUntilExportCompleted(exportId);
            if (!status) {
                return;
            }

            const fileResponse = await this.downloadExport(exportId);
            if (fileResponse?.status !== HttpStatusCode.Ok) {
                return;
            }

            filesService.processFileToDownload(fileResponse, 'Certificates.zip');
        } finally {
            http.apiResponse.clearLoader();
        }
    }

    async sendCertificates(data: CertificateRequest) {
        let response = await http.post(`/certificates/send`, data);

        if (response.status === HttpStatusCode.NoContent) {
            http.apiResponse.showError("[204] No Advisors were found in current period.", AlertTypes.WARNING);
            return;
        }

        if (response.status !== 200) {
            return;
        }
    }
}

export default new CertificatesService();